import { render, staticRenderFns } from "./estatisticas.vue?vue&type=template&id=6888b07c&"
import script from "./estatisticas.vue?vue&type=script&lang=js&"
export * from "./estatisticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports